import { useState } from "react";
import { ScrollableDialogProps } from "./Dialogs";
import { Button, Grid, TextField, Typography } from "@mui/material";
import { gridSizeMdLg12 } from "@/shared/constants";

interface ModalObservacionComponenteProps {
  observacion_cliente: string;
}

export default function ModalObservacionComponente({ observacion_cliente}: Readonly<ModalObservacionComponenteProps>) {

  const [openModalObservacion, setOpenModalObservacion] = useState<boolean>(false);

  if (observacion_cliente.length <= 39) return <Typography>{observacion_cliente}</Typography>

  return <>
    <Typography>
      {`${observacion_cliente.substring(0, 40)}...`}
      <Button
        size="small"
        variant="text"
        onClick={() => {
          setOpenModalObservacion(true);
        }} >{'Ver Todo'}</Button>
    </Typography>

    {openModalObservacion && (
      <ScrollableDialogProps
        open={openModalObservacion}
        title="Observacion Cliente"
        cancelTextBtn="Cerrar"
        onCloseIcon={() => { setOpenModalObservacion(false) }}
        minWidth="48%"
        contentNode={

          <Grid container spacing={2}>
            <Grid item {...gridSizeMdLg12}>
              <TextField
                value={observacion_cliente}
                size={"medium"}
                fullWidth
                variant="outlined"
                label={'Observación'}
                type={'text'}
                multiline
                rows={6}
              />
            </Grid>
          </Grid>

        }
      />
    )
    }
  </>

}